import memoize from 'lodash/memoize';

export const initConfigs = memoize(async () => {
  const response = await fetch(`${window.runtime_env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/configs`);
  const configs: any = await response.json();
  // eslint-disable-next-line require-atomic-updates
  window.environmentConfigs = configs;
  return configs;
});
